// js
import OverviewArea from '../../components/analytics/OverviewArea';
import { connect } from 'react-redux';
import { makeGetAreaSourcesStats } from '../../selectors/dsa/sourcesSelectors';
import { getSubAreasWithSourcesStats } from '../../selectors/analytics/overviewSelectors';


export const mapStateToProps = (state, props) => {
  const areas = state.dsaConfig.areas;
  const areaId = parseInt( props.params.areaId, 10 );

  let area;
  if (areaId && areas && areas[areaId - 1]) {
    area = areas[areaId - 1] ;
  } else {
    area = null;
  }

  const getAreaSourcesStats = makeGetAreaSourcesStats();
  const subareas = getSubAreasWithSourcesStats(state, areaId);

  return {
    area,
    subareas,
    totalStats: getAreaSourcesStats(state, {area})
  };
};

export const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OverviewArea);



// WEBPACK FOOTER //
// ./src/containers/analytics/OverviewArea.js